import { render, staticRenderFns } from "./ArchetypesTiles.vue?vue&type=template&id=6b627d1e&scoped=true&"
import script from "./ArchetypesTiles.vue?vue&type=script&lang=js&"
export * from "./ArchetypesTiles.vue?vue&type=script&lang=js&"
import style0 from "./ArchetypesTiles.vue?vue&type=style&index=0&id=6b627d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b627d1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VIcon,VRow})
